var render = function render(){var _vm=this,_c=_vm._self._c;return _c('info-header-card',{attrs:{"icon":_vm.instrument_instance.icon(),"header":_vm.header,"rows":_vm.rows}})
}
var staticRenderFns = []

export { render, staticRenderFns }